<template>
  <!-- 操作日志 -->
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="140px" size="mini" style="width: 100%;">
        <div class=" formItemBox">
          <el-form-item label="租户名称:" prop="tenantName">
            <el-input  placeholder="" v-model="searchFrom.tenantName"></el-input>
          </el-form-item>
          <el-form-item label="登录账号:" prop="userAccount">
            <el-input placeholder maxlength="50" v-model="searchFrom.userAccount"></el-input>
          </el-form-item>
          <el-form-item label="登录用户:" prop="userName">
            <el-input placeholder maxlength="30" v-model="searchFrom.userName"></el-input>
          </el-form-item>
          <el-form-item label="操作时间:" prop="createTime">
            <el-date-picker
              v-model="searchFrom.createTimes"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </div>
       <div class="searchBtnBox"  >
         <el-form-item>
            <el-button  type="primary" @click="searchFn" >查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button  type="primary" @click="resetForm('searchFrom')" >重置</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table"  bordersize="mini"
        height="100%" style="width: 100%" center border  class="tableComent">
        <el-table-column type="index" prop="date" width="55" label="序号" ></el-table-column>
        <el-table-column prop="createTime"  :formatter="dateTimeFormat" label="操作时间"  width="170" ></el-table-column>
        <el-table-column prop="infoContent" label="日志内容" min-width="170" show-overflow-tooltip :formatter="emptyFn"></el-table-column>
        <el-table-column prop="userName" label="登录用户" width="150" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="tenantName"  label="租户名称"  width="270" show-overflow-tooltip :formatter="emptyFn"></el-table-column>
        <el-table-column prop="userAccount"  label="登录账号"  width="170" show-overflow-tooltip :formatter="emptyFn"></el-table-column>
        <el-table-column prop="loginIp" label="登录ip"  width="150" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="loginAddress" label="登录地点"  min-width="200" show-overflow-tooltip :formatter="emptyFn"></el-table-column>
        <el-table-column property="loginDevice" label="登录设备" min-width="200" :formatter="emptyFn"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
 </div>
</template>

<script>
import { tInfoLogList } from '@/api/newCrm'
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
export default {
  inject: ['reload'],
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      searchBtnShow: false, // 查询按钮隐藏
      chongZhiBtnShow: false, // 重置按钮隐藏
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: false,
      total: 0,
      // 获取按钮数组
      btnDataList: [],
      btnId: '',
      btnName: '',
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P00IB001', '000P00IB002']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/log')
    this.getLogList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 162) + 'px'
  },
  methods: {
    // 查询
    searchFn () {
      this.getLogList()
    },
    // 获取列表
    getLogList () {
      tInfoLogList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getLogList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getLogList()
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox{
  margin-left: -50px;
}
.inpBox .el-date-editor{
   width: 350px!important;
}
.addinpBox .el-input{
  width: 210px;
}
 .demo-form-inline .el-form-item{
  margin-bottom: 17px!important;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
  /deep/ .hide .el-upload--picture-card {
  display: none;
}
}

 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
